import { george, pr, theme, ui } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

export const ActivateJuniorCard = ({ isOldEnough, handleActivation }: { isOldEnough: boolean, handleActivation: () => void }) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    return (


        <george.Card
            elevated={false}
            style={{ borderRadius: 8, padding: theme.MARGIN, marginBottom: theme.MARGIN_SMALL }}
        >
            <div style={{ display: "flex", alignItems: "center" }}>
                <div
                    style={{
                        width: 100,
                        height: 100,
                        borderRadius: 8,
                        flexShrink: 0,
                        backgroundColor: ui.isDarkMode ? theme.themeColors.d_grey_200 : "#E7EFFD",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img

                        src={require("../../../../assets/phone-george.svg")}
                        alt="phone-george"
                        style={{
                            width: "80%",
                            height: "100%",
                            borderRadius: 8,
                            objectFit: "contain"
                        }}
                    />
                </div>
                <div style={{ marginLeft: theme.MARGIN, flex: 1 }}>
                    <pr.P_16_TITLE
                        style={{
                            fontWeight: 700,
                            marginBottom: theme.MARGIN_SMALL,
                        }}
                    >
                        {ui.__("gJunior.activate.card.title")}
                    </pr.P_16_TITLE>
                    <pr.P_14_CONTENT
                        style={{
                            marginTop: theme.MARGIN_SMALL,
                            lineHeight: "20px",
                        }}
                    >
                        {ui.__("gJunior.activate.card.description")}
                    </pr.P_14_CONTENT>
                </div>
            </div>
            <div style={{
                textAlign: "center",
                marginTop: theme.MARGIN,
            }}>
                <GdsFakeActionButton
                    color="primary"
                    style={{
                        borderRadius: theme.BORDER_RADIUS_FULL,
                    }}
                    fullWidth={isMobile}
                    onClick={handleActivation}
                    disabled={!isOldEnough}
                >
                    {ui.__("gJunior.activate.button")}
                </GdsFakeActionButton>
            </div>
        </george.Card>

    );
};


// WEBPACK FOOTER //
// ./src/components/gJunior/components/cards/ActivateJuniorCard.tsx